import React from 'react';
import Helmet from 'react-helmet';
import { saveUTMSessionParams } from "pubweb-smokey/dist/utils/utils";
import AffordableIcon from 'pubweb-react-components/dist/components/Icons/AffordableIcon';

import LandingHeader from '../components/LandingHeader/LandingHeader';

import '../styles/index.scss';

import SubpageContainer from '../styles/SubpageStyles';
import SubpageBody from "../components/SubpageBody/SubpageBody";
import SubpageFooter from "../components/SubpageFooter/SubpageFooter";

import { onHelmetChangeClientState } from '../utils/Analytics';
import ScriptTags from '../components/ScriptTags';

import ImageSet from '../utils/ImageSets';

import mobileAffordability from '../images/mobile/subpages-affordability-mobile.jpg';
import tabletAffordability from '../images/tablet/subpages-affordability-tablet.jpg';
import desktopAffordability from '../images/desktop/subpages-affordability-header.jpg';

const Affordability = (props) => {

    // save any utm params to local session cache
    if(props.location && props.location.search) {
        saveUTMSessionParams(props.location.search);
    }

    var backgroundImages = new ImageSet(mobileAffordability, tabletAffordability, desktopAffordability);


    return (
        <SubpageContainer backgroundImages={backgroundImages}>
            <LandingHeader />
            <SubpageBody
                category='affordable'
                headerText="Affordability"
                formHeading="Get the home you want at a price you can afford."
                subHeaderText='Clayton Built&#174; Homes: The Smart Housing Choice'>
                <div className="movin-header">
                    <AffordableIcon />
                    <h3>Get the home you want at a price you can afford.</h3>
                </div>
                <div className="body-container">
                    <div className="body-column-Left">The need for quality built, affordable housing in America has never been greater, and prefabricated housing is a great solution. Clayton Built&#174; homes are constructed in climate controlled building facilities where our homes are not subject to weather delays. This, coupled with being able to purchase many of our building materials, like lumber, flooring, sinks and cabinetry, in bulk allows us to save on building costs and keep our home prices affordable.</div>
                    <div className="body-column-right">When you choose Clayton Built&#174;, you choose a home that is built on a foundation of quality and durability, style and affordability. Make the smart housing decision, and get into the home of your dreams quicker and within your budget. </div>
                </div>
            </SubpageBody>
            <SubpageFooter
                linkNext="/quality"
                linkPrev="/style"
                textNext="Quality"
                textPrev="Style"
            />
            <ScriptTags />
            <Helmet
                onChangeClientState={onHelmetChangeClientState}
                script={[
                    {
                        type: 'text/javascript',
                        innerHTML: `
                        if (typeof fbq !== 'undefined'){
                            fbq('track', 'PageView');
                        }
                        if (typeof gtag !== 'undefined'){
                            gtag('event', 'page_view', {'send_to': 'AW-1040796449','dynx_itemid': 'HIM2018','dynx_pagetype': 'Affordability'});
                            gtag('event', 'conversion', {
                                'allow_custom_scripts': true,
                                'send_to': 'DC-6346097/fall1003/fall10+standard'
                            });    
                        }
                    `
                    }
                ]}
            >
                <title>Have It Made | Affordability | Clayton Homes</title>
            </Helmet>
        </SubpageContainer>
    );
};

export default Affordability;



// WEBPACK FOOTER //
// ./src/pages/affordability.js